var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { derivePath } from 'ed25519-hd-key';
import * as bip39 from 'bip39';
import * as solanaWeb3 from '@solana/web3.js';
import bs58 from 'bs58';
//@ts-ignore
import * as BufferLayout from 'buffer-layout';
import * as splToken from '@solana/spl-token';
import nacl from 'tweetnacl';
import naclUtil from 'tweetnacl-util';
// import { blob } from '@solana/buffer-layout';
// import {
//   ENDPOINT,
//   MAINNET_PROGRAM_ID as PROGRAMIDS,
//   RAYDIUM_MAINNET as RAYDIUM_MAINNET_API,
//   TxVersion,
//   buildTransaction,
//   jsonInfo2PoolKeys,
//   Liquidity,
//   LiquidityPoolKeys,
//   Token,
//   TokenAmount,
//   Percent,
// } from '@raydium-io/raydium-sdk';
// import { getWalletTokenAccount, sendTx } from './utils';
// import { TestTxInputInfo } from './types';
//@ts-ignore
// import { SolidoSDK } from '@lidofinance/solido-sdk';
export class Solana {
    constructor() {
        this.rpcUrl = 'https://solana-mainnet.g.alchemy.com/v2/TY0C-d-2TTj6GHquKvUdOJ60QthiahUL';
        //'https://api.mainnet-beta.solana.com';
        this.ACCOUNT_LAYOUT = BufferLayout.struct([
            BufferLayout.blob(32, 'mint'),
            BufferLayout.blob(32, 'owner'),
            BufferLayout.nu64('amount'),
            BufferLayout.blob(93),
        ]);
        this.connection = new solanaWeb3.Connection(this.rpcUrl);
    }
    createWallet(mnemonic, derivationPathIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const defaultDerivationPath = `m/44'/501'/0'/0'`;
            const seed = bip39.mnemonicToSeedSync(mnemonic);
            const derivedSeed = derivePath(`m/44'/501'/${derivationPathIndex}'/0'`, seed).key;
            const keyPair = solanaWeb3.Keypair.fromSeed(derivedSeed);
            return {
                privateKey: bs58.encode(keyPair.secretKey), // keyPair.secretKey.toString(),
                address: keyPair.publicKey.toBase58(),
            };
        });
    }
    getBalance(accountAddress, tokenAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let balance;
                const publicKey = new solanaWeb3.PublicKey(accountAddress);
                if (tokenAddress) {
                    const tokenPublicKey = new solanaWeb3.PublicKey(tokenAddress);
                    const account = yield this.connection.getTokenAccountsByOwner(publicKey, {
                        mint: new solanaWeb3.PublicKey(tokenAddress),
                    });
                    const tokenMintAccountInfo = yield this.connection.getTokenSupply(tokenPublicKey);
                    const decimals = (_a = tokenMintAccountInfo.value) === null || _a === void 0 ? void 0 : _a.decimals;
                    // console.log('DECIMALS: ', decimals);
                    balance =
                        account.value.length > 0
                            ? this.ACCOUNT_LAYOUT.decode(account.value[0].account.data).amount
                            : 0;
                    return {
                        balanceInUnits: balance,
                        decimals,
                        balance: balance / Math.pow(10, decimals),
                    };
                }
                balance = yield this.connection.getBalance(publicKey);
                return {
                    balanceInUnits: balance,
                    balance: balance / solanaWeb3.LAMPORTS_PER_SOL,
                };
            }
            catch (error) {
                throw error;
            }
        });
    }
    getSendFee(fromAddress, recipientAddress, amount, tokenAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const senderPubkey = new solanaWeb3.PublicKey(fromAddress);
                const recentBlockhash = yield this.connection.getLatestBlockhash();
                const transaction = yield this.getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress, recentBlockhash);
                transaction.feePayer = senderPubkey;
                const fees = yield transaction.getEstimatedFee(this.connection);
                console.log(`Estimated ${amount} ${tokenAddress ? tokenAddress : 'SOL'} transfer cost: ${fees} lamports`);
                if (fees) {
                    const feesInSol = fees / solanaWeb3.LAMPORTS_PER_SOL;
                    return { success: true, fee: { eth: feesInSol === null || feesInSol === void 0 ? void 0 : feesInSol.toString(), usd: '0' } };
                }
                else
                    return { success: false, message: 'Error in calculating fees' };
            }
            catch (err) {
                console.error(err);
                return { success: false, message: err === null || err === void 0 ? void 0 : err.message };
            }
        });
    }
    getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress, recentBlockhash) {
        return __awaiter(this, void 0, void 0, function* () {
            const recipientPubKey = new solanaWeb3.PublicKey(recipientAddress);
            const senderPubkey = new solanaWeb3.PublicKey(fromAddress);
            let transaction = new solanaWeb3.Transaction(recentBlockhash
                ? {
                    recentBlockhash: recentBlockhash.blockhash,
                }
                : {});
            if (tokenAddress) {
                // Get token mint
                const mint = yield splToken.getMint(this.connection, new solanaWeb3.PublicKey(tokenAddress));
                // Get or create associated token accounts for sender and receiver
                const fromTokenAccount = yield splToken.getAssociatedTokenAddress(mint.address, // mint
                senderPubkey // owner
                );
                const recipientTokenAccount = yield splToken.getAssociatedTokenAddress(mint.address, recipientPubKey);
                // Add token transfer instructions to transaction
                transaction.add(splToken.createTransferInstruction(fromTokenAccount, recipientTokenAccount, senderPubkey, amount * Math.pow(10, mint.decimals) // parse the amount
                ));
            }
            else {
                transaction.add(solanaWeb3.SystemProgram.transfer({
                    fromPubkey: senderPubkey,
                    toPubkey: recipientPubKey,
                    lamports: solanaWeb3.LAMPORTS_PER_SOL * amount,
                }));
            }
            return transaction;
        });
    }
    send({ privateKey, fromAddress, recipientAddress, amount, tokenAddress, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let secretKey;
                if (privateKey.split(',').length > 1) {
                    secretKey = new Uint8Array(privateKey.split(','));
                }
                else {
                    secretKey = bs58.decode(privateKey);
                }
                // fetching the public key from the secret key
                const payer = solanaWeb3.Keypair.fromSecretKey(secretKey, {
                    skipValidation: false,
                });
                let txnSignature;
                if (!tokenAddress) {
                    const transaction = yield this.getSendTxnObject(fromAddress, recipientAddress, amount, tokenAddress);
                    // Sign transaction, broadcast, and confirm
                    // confirmTransaction waits for txn to be confirmed
                    txnSignature = yield solanaWeb3.sendAndConfirmTransaction(this.connection, transaction, [
                        payer,
                    ]);
                }
                else {
                    // Error with getSendTxnObject
                    // failed to send transaction: Transaction simulation failed: Error processing Instruction 0: invalid account data for instruction
                    const recipientPubKey = new solanaWeb3.PublicKey(recipientAddress);
                    const mint = yield splToken.getMint(this.connection, new solanaWeb3.PublicKey(tokenAddress));
                    // Get the token account of the from address, and if it does not exist, create it
                    const fromTokenAccount = yield splToken.getOrCreateAssociatedTokenAccount(this.connection, payer, // payer
                    mint.address, // mint
                    payer.publicKey // owner
                    );
                    // Get the token account of the recipient address, and if it does not exist, create it
                    const recipientTokenAccount = yield splToken.getOrCreateAssociatedTokenAccount(this.connection, payer, mint.address, recipientPubKey);
                    txnSignature = yield splToken.transfer(this.connection, payer, fromTokenAccount.address, recipientTokenAccount.address, payer.publicKey, amount * Math.pow(10, mint.decimals) // parse the amount
                    );
                }
                // const tx = await this.connection.getParsedTransaction(txnSignature); // .getTransaction(signature);
                return {
                    success: true,
                    data: {
                        txnId: txnSignature,
                        viewInExplorer: `https://solscan.io/tx/${txnSignature}`,
                        wait: () => __awaiter(this, void 0, void 0, function* () {
                            console.log(`Waiting for ${txnSignature}`);
                            return;
                        }),
                    },
                };
            }
            catch (err) {
                console.error(err);
                return { success: false, message: err === null || err === void 0 ? void 0 : err.message };
            }
        });
    }
    // https://solanacookbook.com/references/keypairs-and-wallets.html#how-to-sign-and-verify-messages-with-wallets
    signMessage(privateKey, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageBytes = naclUtil.decodeUTF8(message);
            const signature = nacl.sign.detached(messageBytes, bs58.decode(privateKey));
            return Buffer.from(signature).toString('hex');
        });
    }
    verifySignature(signature, message, address) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageBytes = naclUtil.decodeUTF8(message);
            const publicKeyBytes = bs58.decode(address);
            const result = nacl.sign.detached.verify(messageBytes, Buffer.from(signature, 'hex'), publicKeyBytes);
            return result;
        });
    }
    waitForTransaction(txnId, confirmations, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirmations && confirmations > 10) {
                yield this.connection.confirmTransaction(txnId, 'finalized');
            }
            else {
                yield this.connection.confirmTransaction(txnId, 'confirmed');
            }
            return true;
        });
    }
}
